import CustomRangeSlider from './components/CustomRangeSlider';
import Calculator from './components/Calculator';
import Modal from './components/Modal';

document.addEventListener('DOMContentLoaded', () => {
   new CustomRangeSlider().init();
   new Calculator();

   handleModal();
});

const handleModal = async (): Promise<void> => {
   const modalElement = document.querySelector<HTMLElement>('.credit-modal') as HTMLElement;
   const togglers = document.querySelectorAll<HTMLElement>('.credit-modal-toggler');

   if (!togglers) return;

   const modal = new Modal(modalElement, togglers, true);

   modal.setValuesOfForm();
};
